'use client';

import { useTranslation, api } from '@weareconceptstudio/core';
import { useState, createContext, useMemo } from 'react';

const DataContext = createContext(null);
export const DataConsumer = DataContext.Consumer;

const DataProvider = (props) => {
	const { selectedLang } = useTranslation();

	const [state, setState] = useState({
		...props.newData,
		prevRoute: null,
	});

	const enableLoading = () => {
		this.setState({ loading: true });
	};

	const disableLoading = () => {
		setState((prev) => ({ ...prev, loading: false }));
	};

	const contactUs = async (data) => {
		return await api.post('contact-us', data);
	};

	const globalData = useMemo(() => state.globalData?.[selectedLang], [selectedLang, state]);

	const methods = {
		enableLoading,
		disableLoading,
		contactUs,
	};

	return <DataContext.Provider value={{ ...state, ...methods, globalData }}>{props.children}</DataContext.Provider>;
};

export default DataProvider;
